import { atom } from 'recoil';

const isDarkThemeState = atom({
  key: 'isDarkTheme',
  default: true, // fallback; we’ll update this later from localStorage
});

export default isDarkThemeState